import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks, isNavActive } from "@/lib/storenav";

/**
 * Hamburger + dropdown with the standard menu, for screens where the inline nav is hidden.
 * The panel is absolutely positioned under the nearest positioned ancestor (every theme header is `sticky`),
 * so it sits directly below the header whatever its height. Colours are passed in so each theme styles it.
 */
export default function MobileNav({ slug, color = "#111", bg = "#fff", accent = "#2563eb", border = "rgba(0,0,0,0.08)" }) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const root = useRef(null);
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    const onDown = (e) => { if (root.current && !root.current.contains(e.target)) setOpen(false); };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onDown);
    return () => { document.removeEventListener("keydown", onKey); document.removeEventListener("mousedown", onDown); };
  }, [open]);

  return (
    <div className="lg:hidden" ref={root}>
      <button type="button" onClick={() => setOpen((o) => !o)} aria-label={open ? "Close menu" : "Open menu"} aria-expanded={open} data-testid="storefront-mobile-menu-btn"
        className="w-10 h-10 rounded-full border flex items-center justify-center transition-colors" style={{ color, borderColor: border }}>
        {open ? <X size={18} /> : <Menu size={18} />}
      </button>
      {open && (
        <nav className="absolute left-0 right-0 top-full z-40 shadow-xl border-t" style={{ background: bg, borderColor: border }} data-testid="storefront-mobile-menu">
          <ul className="max-w-6xl mx-auto px-5 py-2">
            {navLinks(slug).map(([label, to]) => { const on = isNavActive(pathname, slug, to); return (
              <li key={label}>
                <Link to={to} aria-current={on ? "page" : undefined} className="block py-3 text-[15px] font-semibold border-b last:border-0" style={{ color: on ? accent : color, borderColor: border }}
                  data-testid={label === "Track Order" ? "storefront-mobile-track-link" : undefined}>
                  <span className="inline-block rounded-full mr-3 align-middle" style={{ background: accent, width: on ? 8 : 6, height: on ? 8 : 6, opacity: on ? 1 : 0.5 }} />{label}
                </Link>
              </li>
            ); })}
          </ul>
        </nav>
      )}
    </div>
  );
}
